<template>
  <div class="page">
    <div v-if="getModuleConfig('external_member_customer_bind.not_register.step_section.enable_step_section')" class="p-3">
    <SharedStep :steps="getModuleConfig('thanks_page.step_section.steps')" />
    </div>

    <div v-if="getModuleConfig('external_member_customer_bind.not_register.form_title')" class="page__title">
    {{ getModuleConfig("external_member_customer_bind.not_register.form_title") }}
    </div>
    <div v-if="getModuleConfig('external_member_customer_bind.not_register.form_desc')" class="page__desc">
    {{ getModuleConfig("external_member_customer_bind.not_register.form_desc") }}
    </div>

    <div class="page__content" v-if="contentData" v-html="contentData"></div>

    <img
      v-for="image in contentImages"
      :src="image.image_url"
      :key="image.order"
      class="w-100"
    />

    <div class="page__button s-space-y-4">
      <template v-if="showRedirectButton">
        <MemberButton
          v-if="redirectAction"
          button-style="s-btn-outline-primary"
          :button-text="redirectActionConfig.button_text"
          :type="redirectAction"
        ></MemberButton>
        <SharedButton
          v-else
          class="s-btn-outline-primary bg-transparent"
          @click="redirectToIntended"
          :disabled="!redirectActionEnabled"
        >
          {{ redirectActionConfig.button_text }}
        </SharedButton>
      </template>
      <MemberButton
        v-if="showGoToButton"
        :button-text="getModuleConfig('external_member_customer_bind.not_register.go_to_button_text')"
        :button-url="appendAdditionalParameters(getModuleConfig('external_member_customer_bind.not_register.go_to_button_url'), additionalRedirectUrlParemeters)"
        button-style="s-btn-outline-primary"
        type="URL"
      ></MemberButton>
      <MemberButton
        v-if="showSuccessButton"
        :button-text="getModuleConfig('external_member_customer_bind.not_register.button_text')"
        :button-url="appendAdditionalParameters(getModuleConfig('external_member_customer_bind.not_register.button_url'), additionalRedirectUrlParemeters)"
        :type="getModuleConfig('external_member_customer_bind.not_register.button_action')"
      ></MemberButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import SharedStep from "@/components/Page/Liff/Shared/Steps";
import SharedButton from "@/components/Page/Liff/Shared/Button.vue";
import { appendAdditionalParameters } from "@/utils/UrlFormatter";

const BUTTON_TYPE = {
  SUCCESS: "success_button",
  REDIRECT: "redirect_button",
};

export default {
  components: {
    SharedStep,
    MemberButton,
    SharedButton
  },
  computed: {
    ...mapGetters({
      hasIntended: "route/hasIntended",
      buttonDisplayList: "route/buttonDisplayList",
      redirectAction: "route/redirectAction",
    }),
    contentImages() {
      let contentImages = this.getModuleConfig("external_member_customer_bind.not_register.content_images") || []
      contentImages.sort((a, b) => a.order - b.order)
      return contentImages
    },
    contentData() {
      return this.getModuleConfig("external_member_customer_bind.not_register.content") ?? false;
    },
    showPage() {
      return this.getModuleConfig('external_member_customer_bind.not_register.step_section.enable_step_section')
        || this.getModuleConfig('external_member_customer_bind.not_register.form_title')
        || this.getModuleConfig('external_member_customer_bind.not_register.form_desc')
    },
    showGoToButton() {
      return !!this.buttonDisplayList.go_to_button
        || this.getModuleConfig('external_member_customer_bind.not_register.go_to_button_text')
    },
    showSuccessButton() {
      return !!this.buttonDisplayList.success_button
        || this.getModuleConfig('external_member_customer_bind.not_register.button_text')
    },
    showRedirectButton() {
      return !!this.buttonDisplayList.redirect_button
        || this.redirectAction
        || this.redirectActionConfig.button_type.includes(BUTTON_TYPE.REDIRECT)
    },
    redirectActionConfig() {
      return this.getModuleConfig("external_member_customer_bind.not_register.redirect_action") || {
        enable: false,
        button_type: [],
        url_parameter: null,
      };
    },
    redirectActionEnabled() {
      return this.hasIntended && this.redirectActionConfig.enable;
    },
    additionalRedirectUrlParemeters() {
      return this.redirectActionConfig.url_parameter;
    },
  },
  methods: {
    appendAdditionalParameters,
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('member_register', key);
    },
    redirectToIntended() {
      if (!this.$store.state.route.intended) {
        return this.$router.push('/')
      }

      const intended = this.$store.state.route.intended

      this.$store.commit('route/SET_INTENDED', null)

      if (intended.startsWith('http')) {
        return window.location = appendAdditionalParameters(intended, this.additionalRedirectUrlParemeters)
      }

      return this.$router.push(intended)
    },
  },
};
</script>
